<template>
  <div class="input-text-component">
    <FormKit
      v-model="value"
      type="text"
      :placeholder="placeholder"
      :validation="rules"
      :validation-messages="validationMessages"
      validation-visibility="submit"
      :label="props.label"
      :max="999999"
      :maxlength="7"
      @input="handleInput">
      <template #label="context">
        <label v-if="context.label" class="formkit-label">
          {{ context.label }}
          <span v-if="required" class="text-sm text-brand-primary">*</span>
        </label>
      </template>
      <template #suffixIcon>
        <span class="text-sm font-normal pr-3 text-neutral3 dark:text-dmText3">{{ currencyCode }}</span>
      </template>
    </FormKit>
  </div>
</template>

<script lang="ts" setup>
import { useStoreConfig } from '~/store/storeConfig'
import type { FormKitNode } from '@formkit/core'

const { t } = useLang()
const props = defineProps({
  value: {
    type: String,
    default: '',
    required: false,
  },
  label: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
    required: false,
  },
})

const value = ref<string>(props.value)
const rules = ref(
  props.required ? 'required|number|min:1|max:9999999|length:1,7' : 'number|min:1|max:9999999|length:1,7'
)

const validationMessages = computed(() => ({
  required: t('validation.required'),
  number: t('validation.number'),
  min: (context: { args: Array<any>; name: string; node: FormKitNode }) =>
    t('validation.min_number', { value: context.args[0] }),
  length: (context: { args: Array<any>; name: string; node: FormKitNode }) => {
    if (context.args[1]) {
      return t('validation.length_between', { min: context.args[0], max: context.args[1] })
    }

    return t('validation.min_length', { length: context.args[0] })
  },
}))

const storeConfig = useStoreConfig()
const currencyCode = computed(() => storeConfig.getSelectedCurrency?.iso_code)

watch(
  () => props.value,
  (property) => {
    value.value = property
  }
)

const emit = defineEmits(['handle'])

function handleInput(value: string) {
  emit('handle', value)
}
</script>
